import {z} from 'zod';

import {isValidDate, isValidNumber} from '../../utils/utils';
import {FieldFormat} from '../dto/response/FieldTypeResponseDto';

import type {FieldTypeResponseDto} from '../dto';

export const extendedSearchFilterSchema = z.object({
  field: z.string().min(1, 'Bitte ein Feld auswählen'),
  operator: z.string().min(1, 'Bitte einen Operator auswählen'),
  value: z
    .string()
    .refine(value => value.trim().length > 0, 'Bitte einen Wert angeben'),
});

export type ExtendedSearchFilterFormValues = z.infer<
  typeof extendedSearchFilterSchema
>;

export interface ExtendedSearchFormValues {
  logicalConnector: string;
  filters: ExtendedSearchFilterFormValues[];
}

export const createExtendedSearchSchema = (
  fieldTypes: Map<string, FieldTypeResponseDto>,
) =>
  z.object({
    logicalConnector: z.string(),
    filters: z.array(
      extendedSearchFilterSchema.superRefine((filter, ctx) => {
        const format = fieldTypes.get(filter.field)?.format;
        if (format === FieldFormat.DATE && !isValidDate(filter.value)) {
          ctx.addIssue({
            code: 'custom',
            path: ['value'],
            message: 'Bitte valides Datumformat angeben (TT.MM.JJJJ)',
          });
        }
        if (format === FieldFormat.NUMBER && !isValidNumber(filter.value)) {
          ctx.addIssue({
            code: 'custom',
            path: ['value'],
            message: 'Bitte valide Zahl angeben (maximal 2 Nachkommastellen)',
          });
        }
      }),
    ),
  });
